// Comercial → Licitações (oportunidades públicas via ConLicitação + PNCP).
//
// Entry fino. Após refactor de 2026-05-23 (frontend wave 3B), a lista, os
// modais e as constantes/tipos moram em ./comercial-licitacoes/.
// Desde 2026-09-02 esta página é SÓ a lista de oportunidades: Documentos da
// empresa e Configurações viraram abas do hub (ComercialLicitacoesHub), cada
// uma com a própria página em ./comercial-licitacoes/.
import { Typography, App as AntApp } from 'antd';
import { AbaOportunidades } from './comercial-licitacoes/AbaOportunidades';

const { Title, Text } = Typography;

function ComercialLicitacoesInner() {
  return (
    <div style={{ width: '100%', margin: '16px 0', padding: '0 24px', boxSizing: 'border-box' }}>
      <Title level={4} style={{ margin: 0, color: '#020D7F' }}>Licitações Públicas</Title>
      <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 14 }}>
        Oportunidades sincronizadas do <strong>PNCP</strong> + <strong>ConLicitação</strong>, filtradas por
        palavras-chave e UFs configuradas.
      </Text>
      <AbaOportunidades />
    </div>
  );
}

export default function ComercialLicitacoes() {
  return (
    <AntApp>
      <ComercialLicitacoesInner />
    </AntApp>
  );
}
